import { SelectableItem } from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

enum nasRadio {
  NO = 0,
  YES = 1,
}
export const radioExpressionData: SelectableItem[] = [
  {
    key: String(nasRadio.NO),
    label: MessageService.translate('tws.emar.button-no'),
    value: String(nasRadio.NO),
  },
  {
    key: String(nasRadio.YES),
    label: MessageService.translate('tws.emar.button-yes'),
    value: String(nasRadio.YES),
  },
]
